const NEW_LEAD = '/new-lead';
const SIGN_UP = '/signup';
const LOGIN = '/login';
const CUSTOMER_LOGIN = '/customer/login';
const ADMIN_LEADS = '/admin/leads';
const ADMIN_PAYMENTS = '/admin/leads/:leadId/payments';
const ADMIN_DASHBOARD = '/admin/dashboard';
const CUSTOMER_DASHBOARD = '/customer/dashboard';
const LEADS_LIST = '/leads';
export { NEW_LEAD, SIGN_UP, LOGIN, CUSTOMER_LOGIN, ADMIN_LEADS ,ADMIN_PAYMENTS,ADMIN_DASHBOARD, CUSTOMER_DASHBOARD, LEADS_LIST}